baseApp.service('CopyToClipboardService', ['GeneralUtilsService', function(GeneralUtilsService, $rootScope) {

    let copyToClipboardService = {};

    copyToClipboardService.copy = function(stringWithNewLines) {
        // create temp element
        var copyElement = document.createElement("textarea");
        copyElement.innerHTML = stringWithNewLines;
        // add to the document
        document.body.append(copyElement);
        // select the text
        copyElement.select();
        // copy
        document.execCommand('copy');
        // remove the element
        copyElement.remove();
    }


    return copyToClipboardService;
}]);